<template>
  <div class="form-block" style="=padding-top: 0 !important;">
    <div class="container-fluid">

      <div class="row" v-if="declarationType === 'A'">
        <div class="col-12">
          <h2>Dane adresowe budynku</h2>
        </div>

        <div class="col-xs-12 col-md-5 no-right-padding">
          <p class="address">{{ street }} {{ number }},
            {{ building.postal_code }} {{ building.city.name }}</p>
        </div>

        <div class="col-xs-12 col-md-7 no-side-padding smargintop">
          <label class="declaration-date" id="checkbox2021">
            <input type="checkbox" v-model="after01072021"/>
            Deklaracja dotyczy źródła ciepła/spalania paliw uruchomionego po 1 lipca 2021 r.
            <span class="checkmark"></span>
            <b-tooltip target="checkbox2021" triggers="hover" data-delay='{"hide":"2000"}'>
              1. Jeżeli składasz deklarację dla budynku, dla którego określasz <b>kilka</b> źródeł ciepła i spalania paliw, a <b>chociażby jedno</b> z nich zostało uruchomione po 1.07.2021 r. – zaznacz checkbox! W innym wypadku, checkbox pozostaw odznaczony.
              <br/>
              2. Każdorazowa wymiana źródła ciepła/spalania paliw wymaga złożenia nowej deklaracji!
            </b-tooltip>
          </label>
        </div>


        <div class="col-12">
          <hr/>
        </div>


        <div class="col-12">
          <h2>Rodzaj budynku</h2>
        </div>
        <div class="col-12">
          <label>
            <input
              id="singleOrMultiFamily"
              type="radio"
              value="single"
              v-model="singleOrMultiFamily"
            >
            Budynek jednorodzinny (w tym w zabudowie bliżniaczej i szeregowej)
          </label>
        </div>
        <div class="col-12">
          <label>
            <input
              type="radio"
              value="multi"
              v-model="singleOrMultiFamily"
            >
            Budynek wielorodzinny
          </label>

          <label>
            <input
              class="text-input w-small side-margins"
              type="text"
              v-model="multiFamilyCount"
              :disabled="singleOrMultiFamily !== 'multi'"
              :class="{
                'disabled': singleOrMultiFamily !== 'multi',
                'error': errors.multiFamilyCount
              }"
            />
            Liczba wszystkich lokali mieszkalnych w budynku
          </label>
        </div>
        <div class="col-12">
          <label>
            <input
              value="isTemporary"
              type="radio"
              v-model="singleOrMultiFamily"
              id="isTemporaryCheckbox"
            >
            Budynek zbiorowego zamieszkania
            <b-tooltip target="isTemporaryCheckbox" triggers="hover">
              Budynek zbiorowego zamieszkania to budynek przeznaczony do okresowego pobytu ludzi, w szczególności hotel, motel, pensjonat, dom wypoczynkowy, dom wycieczkowy, schronisko młodzieżowe, schronisko, internat, dom studencki, budynek koszarowy, areszt śledczy itp., a także budynek do stałego pobytu ludzi, np. dom dziecka, dom rencistów, dom zakonny.
            </b-tooltip>
          </label>
          <label>
            <input
              class="text-input w-small side-margins"
              type="text"
              :disabled="singleOrMultiFamily !== 'isTemporary'"
              :class="{
                'disabled': singleOrMultiFamily !== 'isTemporary',
                'error': errors.temporaryCount
              }"
              v-model="temporaryCount"

            />
            Liczba wszystkich lokali zbiorowego zamieszkania w budynku
          </label>
        </div>
        <div class="col-12">
          <h2>Deklaracja dotyczy</h2>
        </div>
        <div class="col-12">
          <label>
            <input
              type="radio"
              :value="true"
              v-model="isAllPremises"
            >
            Wszystkich lokali mieszkalnych / zbiorowego zamieszkania w budynku
          </label>
        </div>
        <div class="col-12">
          <label>
            <input
              type="radio"
              :value="false"
              v-model="isAllPremises"
            >
            Wybranych lokali mieszkalnych / zbiorowego zamieszkania w budynku
          </label>
        </div>
        <div class="col-12">
          <label>
            <input
              class="text-input w-small"
              type="text"
              v-model="premisesCount"
              :disabled="isAllPremises"
              :class="{
                'disabled': isAllPremises || singleOrMultiFamily === 'single',
                'error': errors.premisesCount
              }"
            />
            Liczba lokali mieszkalnych / zbiorowego zamieszkania objętych  deklaracją
          </label>
        </div>
        <div class="col-12">
          <label>
            <input
              class="text-input"
              type="text"
              v-model="premisesList"
              :disabled="isAllPremises"
              :class="{
                'disabled': isAllPremises || singleOrMultiFamily === 'single',
                'error': errors.premisesList
              }"
            />
            Numery lokali mieszkalnych / zbiorowego zamieszkania objętych deklaracją
          </label>
        </div>
      </div>


      <!-- ################ -->
      <!-- # Deklaracja B # -->
      <!-- ################ -->

      <div class="row" v-if="declarationType === 'B'">
        <div class="col-12">
          <h2>Dane adresowe budynku</h2>
        </div>

        <div class="col-xs-12 col-md-5">
          <p class="address">{{ street }} {{ number }},
            {{ building.postal_code }} {{ building.city.name }}</p>
        </div>

        <div class="col-xs-12 col-md-7 smargintop">
          <label id="specialSign">
            Symbol / oznaczenie specjalne budynku
            <input type="text" class="text-input" ref="cityInput" v-model="special_symbol_A08_B"/>
            <b-tooltip target="specialSign" triggers="hover">
              1. Mogą to być symbole literowe np. budynek A, B, C, które nie stanowią jednak elementu oficjalnego adresu lub np. oznaczenie opisowe (np. kompleks budynków uczelnianych, gdzie opisuje się budynki funkcjami w stylu ‘Biblioteka’, ‘Basen’)
            </b-tooltip>
          </label>

          <label class="declaration-date" id="checkbox2021B">
            <input type="checkbox" v-model="after01072021"/>
            Deklaracja dotyczy źródła ciepła/spalania paliw uruchomionego po 1 lipca 2021 r.
            <span class="checkmark"></span>
            <b-tooltip target="checkbox2021B" triggers="hover">
              1. Jeżeli składasz deklarację dla budynku, dla którego określasz <b>kilka</b> źródeł ciepła i spalania paliw, a <b>chociażby jedno</b> z nich zostało uruchomione po 1.07.2021 r. – zaznacz checkbox! W innym wypadku, checkbox pozostaw odznaczony.
              <br/>
              2. Każdorazowa wymiana źródła ciepła/spalania paliw wymaga złożenia nowej deklaracji!
            </b-tooltip>
          </label>
        </div>

        <div class="col-12">
          <hr/>
        </div>

        <div class="col-xs-12 col-md-6 declaration-b-item" v-for="(buildingType, index) in selectedBuildingTypes">
          <label style="font-size: .9rem;">
            <input
              type="checkbox"
              v-model="selectedBuildingTypes[index].selected"
            >
            {{ buildingType.description }}
          </label>
        </div>

        <div class="col-12">
          <h2>Określ, czego dotyczy deklaracja?</h2>
        </div>

        <div class="col-xs-12 col-md-4">
          <label>
            <input
              :value="true"
              type="radio"
              v-model="isAllPremises"
            />
            Całego budynku
          </label>

          <label>
            <input
              :value="false"
              type="radio"
              v-model="isAllPremises"
            />
            Wybranych lokali w budynku
          </label>

        </div>

        <div class="col-xs-12 col-md-8">
          <label id="b-locals-symbols">
            <input
              type="text"
              class="text-input"
              v-model="premisesList"
              :disabled="isAllPremises"
              :class="{
                'disabled': isAllPremises,
                'error': errors.premisesList
              }"
            />
            <span class="is-temporary-b">Numery / symbole / oznaczenia specjalne lokali niemieszkalnych objętych deklaracją</span>
          </label>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import Common from "@/components/declarations/validators/Common";
import DeclarationsModel from "@/models/declarations";
import DeclarationsMixin from "@/mixins/DeclarationsMixin";

export default {
  name: "FirstScreen",
  props: ['building'],
  mixins: [Common, DeclarationsMixin],
  data() {
    return {
      singleOrMultiFamily: null,
      multiFamilyCount: null,
      temporaryCount: null,
      isAllPremises: null,
      premisesCount: null,
      premisesList: "",
      after01072021: false,

      special_symbol_A08_B: "",
      selectedBuildingTypes: [],
    }
  },
  methods: {
    async setData(data) {
      this.singleOrMultiFamily = data.is_temporary_A08_03 ? 'isTemporary' : (data.is_single_family_A08_01 ? "single" : "multi");
      this.multiFamilyCount = data.multi_family_count;
      this.isTemporary = data.is_temporary_A08_03;
      this.temporaryCount = data.temporary_count;
      this.isAllPremises = data.is_all_premises;
      this.premisesCount = data.premises_count_A09_02;
      this.premisesList = data.premises_list_A09_02;
      this.after01072021 = data.after_01_07_2021;

      this.special_symbol_A08_B = data.special_symbol_A08_B;
      if (!this.selectedBuildingTypes.length) {
        await this.getBuildingTypes();
      }

      if (data.building_types) {
        data.building_types.forEach((el) =>
          this.selectedBuildingTypes.find((sBT) => sBT.abbreviation === el.type.abbreviation).selected = true
        )
      }
    },
    emitChange() {
      const data = {
        singleOrMultiFamily: this.singleOrMultiFamily,
        multiFamilyCount: this.multiFamilyCount,
        isTemporary: this.singleOrMultiFamily === 'isTemporary',
        temporaryCount: this.temporaryCount,
        isAllPremises: this.isAllPremises,
        premisesCount: this.premisesCount,
        premisesList: this.premisesList,
        after01072021: this.after01072021,

        specialSymbolA08B: this.special_symbol_A08_B,
        buildingTypes: this.selectedBuildingTypes.filter((el) => el.selected).map((el) => el.abbreviation),
      };
      this.$emit('update', data);
    },
    getBuildingTypes() {
      DeclarationsModel.getBuildingTypesForB()
        .then((res) => {
          this.selectedBuildingTypes = res.data.map((el) => {
            el.selected = false;
            return el;
          });

        });
    }
  },
  computed: {
    street() {
      let result = "";
      if (this.building.street) {
        result = this.building.street.name;
      } else {
        let customStreetName = this.building.custom_street_name;
        result = customStreetName.length ? `ul. ${customStreetName}` : customStreetName;
      }
      return result;
    },
    number() {
      return this.building.number ? this.building.number.name : this.building.custom_number;
    }
  },
  watch: {
    singleOrMultiFamily(newValue, oldValue) {
      if ((oldValue == null) || (!oldValue.length))
        return;
      if (oldValue === 'multi') {
        this.multiFamilyCount = null;
      }
      if (oldValue === 'isTemporary') {
        this.temporaryCount = null;
      }
      if (newValue === 'single') {
        this.premisesCount = null;
        this.premisesList = "";
        this.isAllPremises = true;
      }
    },
    isAllPremises(newValue, oldValue) {
      if (oldValue == null)
        return;
      if (!oldValue) {
        this.premisesCount = null;
        this.premisesList = "";
      }
    }
  },
  async mounted() {
    await this.getBuildingTypes();
    // setTimeout(() => document.getElementById("singleOrMultiFamily").focus(), 1);
  }
}
</script>

<style scoped>
h1, h2, h3, h4, label, p {
  color: #707070;
}

hr {
  border: 0;
  border-top: 2px solid #dadada;
  width: 65rem;
  margin-left: -2.45rem;
  padding-right: 3rem;
  margin-top: 0;
}

h1 {
  font-size: 1.3rem;
}

h2 {
  font-size: 1.2rem;
  font-family: "Volte Semibold", serif;
}

.address {
  font-size: 1.3rem;
}

.text-input {
  height: 2rem;
  width: fit-content;
}

.half-input {
  width: fit-content;
  min-width: 50%;
  margin-left: .5rem;
}

.locals-count-input {
  margin-bottom: .25rem;
}

@media (max-height: 770px) {
  #b-locals-symbols {
    max-width: 36rem;
  }

  .declaration-b-item {
    margin-bottom: -.3rem;
  }

  .is-temporary-b, label {
    font-size: 0.9rem;
  }

  .is-temporary-b {
    left: 14rem !important;
  }
}

.is-temporary-b {
  position: absolute;
  left: 16rem;
  top: -.3rem;
}

.no-right-padding {
  padding-right: 0;
}

.no-side-padding {
  padding-left: 0;
  padding-right: 0;
}

.declaration-date {
  font-size: .9rem;
}

.smargintop {
 margin-top: -2rem;
}

@media screen and (max-width: 768px) {
  .smargintop {
    margin-top: 0;
  }

  .address {
    font-size: 1em;
  }
}


</style>
